<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gbnqOx/tc-custom/9781645365907.jpg?1680021489299" alt="This image is the cover for the book Nancy and the Christmas Story"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nancy and the Christmas Story
      </h1>
      <p class="bookDescription body article font2">
        <p>Nancy experienced culture shock when she moved to a new city. The belief that Santa Claus existed confused her. And the reason people thought they celebrated Christmas was entirely different from what she knew.</p><p>However, her discovery of the difference between Santa Claus and Jesus Christ saved the world. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pamela Malu
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'>Pamela Malu is a first-time author originally from D.R. Congo and currently based in Canada, Winnipeg, together with her husband, D.K. Gui, and their five kids. She is a lover of reading, writing, and blogging. Her passion for writing started when she was a child, but she always wanted to write romance novels. However, reading to her kids every night before bed drew her interest in children&rsquo;s books.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fc624364